const queryPartnerProfileDetails = (affiliateCode) => `
{
  metaobject(handle: {handle: "${affiliateCode}", type: "partner_profile_details"}) {
    id
    handle
    fields {
      key
      type
      value
    }
  }
}`;

async function fetchPartnerProfileDetails(affiliateCode) {
  const accessToken = 'f540e469e1c6196a65cc6f56644d66d2';
  //console.log(`Fetching partner profile details for affiliate code: ${affiliateCode}`);

  try {
    const response = await fetch('/api/2024-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': accessToken,
      },
      body: queryPartnerProfileDetails(affiliateCode),
    });

    //console.log('Received response status:', response.status);

    if (!response.ok) {
      throw new Error(`Error fetching partner profile details: ${response.statusText}`);
    }

    const responseBody = await response.json();
    //console.log("Received partner profile details from server:", responseBody);

    if (responseBody?.data?.metaobject?.fields) {
      const fields = responseBody.data.metaobject.fields;
      //console.log('Fields:', fields);
      updateDoctorInfoSlider(fields);
    } else {
      //console.log('No matched profile found.');
    }
  } catch (error) {
    console.error('Failed to fetch partner profile details:', error);
  }
}

async function checkImageExists(url) {
  //console.log(`Checking if image exists at URL: ${url}`);
  try {
    const response = await fetch(url, { method: 'HEAD' });
    return response.ok;
  } catch (error) {
    console.error(`Error checking image at URL ${url}:`, error);
    return false;
  }
}

async function getProvidersImageUrl(affiliateCode) {
  const baseUrl = `https://cdn.shopify.com/s/files/1/0740/5984/1838/files/${affiliateCode}_providers`;
  const altBaseUrl = `https://cdn.shopify.com/s/files/1/0740/5984/1838/files/${affiliateCode}_prov`;
  const logoUrl = `https://cdn.shopify.com/s/files/1/0740/5984/1838/files/${affiliateCode}_Logo`;
  const extensions = ['.jpg', '.jpeg', '.png'];

  for (const ext of extensions) {
    const url = `${baseUrl}${ext}`;
    const exists = await checkImageExists(url);
    if (exists) {
      //console.log(`Providers image URL found: ${url}`);
      return url;
    }
  }

  for (const ext of extensions) {
    const altUrl = `${altBaseUrl}${ext}`;
    const exists = await checkImageExists(altUrl);
    if (exists) {
      //console.log(`Alternate providers image URL found: ${altUrl}`);
      return altUrl;
    }
  }

  for (const ext of extensions) {
    const url = `${logoUrl}${ext}`;
    const exists = await checkImageExists(url);
    if (exists) {
      //console.log(`Logo URL found: ${url}`);
      const isMobile = window.innerWidth <= 768;

      if (isMobile) {
        const sectionRowDiv = document.querySelector("#shopify-section-template--20562732679470__2c6aa4b4-0cab-475f-96ce-d071ba76d2fa .section-row .background-size-cover");
        sectionRowDiv.style.marginRight = '30%';
        sectionRowDiv.style.width = '70%';
      } else {
        const sectionRowDiv = document.querySelector("#shopify-section-template--20562732679470__2c6aa4b4-0cab-475f-96ce-d071ba76d2fa .section-row .background-size-cover");
        sectionRowDiv.style.marginRight = '35%';
        sectionRowDiv.style.width = '30%';
      }

      return url;
    } else {
      //console.log(`Logo URL NOT found: ${url}`);
    }
  }

  //console.log('No suitable image URL found.');
  return null;
}

async function updateDoctorInfoSlider(fields) {
  //console.log('Updating doctor info slider...');

  const practiceDescField = fields.find(field => field.key === 'practiceDesc')?.value;
  const practiceDesc = practiceDescField ? JSON.parse(practiceDescField).children.map(child => child.children.map(c => c.value).join('')).join('') : null;

  const affiliateCode = fetchAffiliateCode();
  //console.log('Affiliate code for updating doctor info slider:', affiliateCode);
  
  const providersImageUrl = await getProvidersImageUrl(affiliateCode);
  //console.log('Providers Image URL for doctor info slider:', providersImageUrl);

  const sectionRowP = document.querySelector("#shopify-section-template--20562732679470__2c6aa4b4-0cab-475f-96ce-d071ba76d2fa .section-row p");
  const sectionRowDiv = document.querySelector("#shopify-section-template--20562732679470__2c6aa4b4-0cab-475f-96ce-d071ba76d2fa .section-row .background-size-cover");

  if (sectionRowP && practiceDesc) {
    sectionRowP.innerHTML = practiceDesc.replace(/\n/g, '<br>');
    //console.log('Practice description updated in DOM.');
  } else {
    //console.log('Could not find or update practice description.');
  }

  if (sectionRowDiv && providersImageUrl) {
    let bgset = sectionRowDiv.getAttribute('data-bgset');
    let imageUrl = providersImageUrl;
    if (bgset) {
      let newBgset = bgset.replace(/\/\/[^ ]+/g, imageUrl);
      sectionRowDiv.setAttribute('data-bgset', newBgset);
      //console.log('Updated data-bgset attribute.');
    }

    sectionRowDiv.style.backgroundImage = `url(${imageUrl})`;
    sectionRowDiv.style.backgroundSize = 'contain';
    sectionRowDiv.style.backgroundRepeat = 'no-repeat';
    sectionRowDiv.style.backgroundPosition = 'center';

    //console.log('Background image updated.');
  } else {
    //console.log('Could not find or update background image.');
  }

  const sectionRow = document.querySelector("#shopify-section-template--20562732679470__2c6aa4b4-0cab-475f-96ce-d071ba76d2fa .section-row");
  if (sectionRow) {
    sectionRow.style.display = "block";
    //console.log('Section row is now visible.');
  } else {
    //console.log('Could not find section row.');
  }
}

function fetchAffiliateCode() {
  //console.log('Fetching affiliate code...');
  const urlParams = new URLSearchParams(window.location.search);
  const codeParam = urlParams.get('code');
  let affiliateCode = null;

  if (codeParam) {
    const [code, providerId] = codeParam.split('-');
    affiliateCode = code;

    localStorage.setItem('affiliateCode', affiliateCode);
    sessionStorage.setItem('affiliateCode', affiliateCode);
    //console.log(`Affiliate code set: ${affiliateCode}`);

    if (providerId) {
      localStorage.setItem('providerId', providerId);
      sessionStorage.setItem('providerId', providerId);
      console.log(`Provider ID set: ${providerId}`);
    }
  } else {
    affiliateCode = localStorage.getItem('affiliateCode') || sessionStorage.getItem('affiliateCode');
    //console.log('Retrieved affiliate code from storage:', affiliateCode);
  }

  return affiliateCode;
}

async function fetchProviderName(providerId, affiliateId) {
  try {
    const response = await fetch(`https://merchant-api.skintypesolutions.com/api/fms-affiliates/providers-by-affiliate-id/${affiliateId}`);
    const providersData = await response.json();
    const provider = providersData.find(provider => provider.user_affiliate_id == providerId);
    //console.log(`Fetched provider name: ${provider ? provider.full_name : 'Not found'}`);
    return provider ? provider.full_name : '';
  } catch (error) {
    console.error("Error fetching provider name:", error);
    return '';
  }
}

async function fetchAffiliateId(affiliateCode) {
  try {
    const response = await fetch(window.affiliateNamesJSONURL);
    const affiliatesData = await response.json();
    const matchedAffiliate = affiliatesData.find(affiliate => affiliate.affiliateCode === affiliateCode);
    //console.log(`Fetched affiliate ID: ${matchedAffiliate ? matchedAffiliate.affiliateId : 'Not found'}`);
    return matchedAffiliate ? matchedAffiliate.affiliateId : null;
  } catch (error) {
    console.error("Error fetching affiliate data:", error);
    return null;
  }
}

async function updateCartAttributes(affiliateCode) {
  //console.log('Updating cart attributes with affiliate code:', affiliateCode);

  const providerId = localStorage.getItem('providerId') || "";
  let providerName = '';
  let affiliateId = null;

  if (affiliateCode) {
    affiliateId = await fetchAffiliateId(affiliateCode);
  }

  if (providerId && affiliateId) {
    providerName = await fetchProviderName(providerId, affiliateId);
  }

  const providerAttribute = providerId ? `${providerId}-${providerName}` : '';

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ 
      attributes: { 
        affiliateCode: affiliateCode,
        providerId: providerAttribute 
      } 
    }),
  })
    .then(response => {
      if (response.ok) {
        //console.log('Cart attributes updated successfully.');
      } else {
        console.error('Failed to update cart attributes. Response:', response);
      }
    })
    .catch(error => console.error('Error updating cart attributes:', error));
}

// Modified updateLogoLink: Accepts affiliateCode, sets href, no custom click listener
function updateLogoLink(affiliateCode) { // Accepts affiliateCode
  const logoLinks = document.querySelectorAll('.header__logo__link, .mobile-nav__logo-link');
  const idealTargetURL = 'https://ww2.idealimage.com/';
  
  if (logoLinks.length > 0) {
    logoLinks.forEach(logoLink => {
      if (affiliateCode === 'IDEAL') {
        // Only update href if it's different
        if (logoLink.getAttribute('href') !== idealTargetURL) {
          logoLink.setAttribute('href', idealTargetURL);
        }
        // Removed the addEventListener part that used e.preventDefault()
      }
      // If affiliateCode is not IDEAL, this function does not alter the link
      // with respect to idealTargetURL. If it was previously set to idealTargetURL
      // and the code changes, it remains, unless other page logic resets it.
    });
  }
}

function updateCollectionUrl() {
  const affiliateCode = localStorage.getItem('affiliateCode');
  
  // Check if primary_brand_collection metafield is true
  const primaryBrandCollection = window.primaryBrandCollection;
  console.log('Primary Brand Collection Metafield:', typeof primaryBrandCollection, primaryBrandCollection);
  
  // Check if filters have been manually cleared in this session
  if (sessionStorage.getItem('filtersManuallyCleared')) {
    console.log('Skipping collection URL update because filters were manually cleared');
    return;
  }
  
  if (primaryBrandCollection === true || primaryBrandCollection === 'true') {
    console.log('Skipping collection URL update due to primary_brand_collection being true');
    return; // Exit function if metafield is true
  }
  
  if (affiliateCode === 'IDEAL' && window.location.pathname.includes('/collections/')) {
    const currentUrl = new URL(window.location.href);
    const searchParams = new URLSearchParams(currentUrl.search);
    
    // Only modify if brand filters aren't already present
    if (!searchParams.has('pf_v_brand')) {
      searchParams.append('pf_v_brand', 'EltaMD');
      searchParams.append('pf_v_brand', 'Neocutis');
      searchParams.append('pf_v_brand', 'SkinMedica');
      
      // Create the new URL with filters
      currentUrl.search = searchParams.toString();
      
      // Redirect to the new URL instead of using replaceState
      window.location.href = currentUrl.toString();
    }
  }
}

// Add function to set up filter clear detection
function setupFilterClearListeners() {
  // Function to handle when filters are cleared
  const handleFilterClear = (e) => {
    console.log('Filters manually cleared', e.target);
    sessionStorage.setItem('filtersManuallyCleared', 'true');
  };

  // Set up a mutation observer to catch when the filter buttons are added to the DOM
  const observer = new MutationObserver((mutations) => {
    // Look for the "Clear All" button - try different selectors
    const clearAllButton = document.getElementById('boost-sd__button--clear-all-filters') || 
                          document.querySelector('[aria-label="Clear All"]') ||
                          document.querySelector('.boost-sd__button--clear');
                          
    if (clearAllButton && !clearAllButton.hasAttribute('data-listener-added')) {
      clearAllButton.setAttribute('data-listener-added', 'true');
      clearAllButton.addEventListener('click', handleFilterClear);
      console.log('Added listener to Clear All button', clearAllButton);
    }

    // Look for individual X buttons - try multiple selectors to ensure we catch them
    const filterButtons = document.querySelectorAll('.boost-sd__refine-by-vertical-refine-by-clear, [metadata*="clearFilter"], svg[aria-label="Clear All"]');
    filterButtons.forEach(button => {
      if (!button.hasAttribute('data-listener-added')) {
        button.setAttribute('data-listener-added', 'true');
        button.addEventListener('click', handleFilterClear);
        console.log('Added listener to filter clear button', button);
        
        // Also add listeners to parent elements, as sometimes the click events bubble up
        let parent = button.parentElement;
        for (let i = 0; i < 3 && parent; i++) { // Check up to 3 levels of parents
          if (!parent.hasAttribute('data-listener-added')) {
            parent.setAttribute('data-listener-added', 'true');
            parent.addEventListener('click', handleFilterClear);
          }
          parent = parent.parentElement;
        }
      }
    });
  });

  // Start observing the document for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true
  });
  
  // Additionally, add a delegated event listener to catch any filter clear actions
  document.addEventListener('click', (e) => {
    // Check if the clicked element or any of its parents has attributes or classes related to clearing filters
    let target = e.target;
    for (let i = 0; i < 5 && target; i++) { // Check up to 5 levels up the DOM
      if (
        target.matches('[aria-label="Clear All"], .boost-sd__button--clear, .boost-sd__refine-by-vertical-refine-by-clear') ||
        (target.getAttribute('metadata') && target.getAttribute('metadata').includes('clearFilter')) ||
        target.id === 'boost-sd__button--clear-all-filters' ||
        (target.getAttribute('class') && target.getAttribute('class').includes('boost-sd__button--clear'))
      ) {
        console.log('Delegated filter clear detected', target);
        sessionStorage.setItem('filtersManuallyCleared', 'true');
        break;
      }
      target = target.parentElement;
    }
  });
  
  // Immediately check for existing buttons
  setTimeout(() => {
    const initialClearAllButton = document.getElementById('boost-sd__button--clear-all-filters') || 
                                 document.querySelector('[aria-label="Clear All"]') ||
                                 document.querySelector('.boost-sd__button--clear');
    if (initialClearAllButton) {
      initialClearAllButton.addEventListener('click', handleFilterClear);
      console.log('Added initial listener to Clear All button');
    }
    
    const initialFilterButtons = document.querySelectorAll('.boost-sd__refine-by-vertical-refine-by-clear, [metadata*="clearFilter"], svg[aria-label="Clear All"]');
    initialFilterButtons.forEach(button => {
      button.addEventListener('click', handleFilterClear);
      console.log('Added initial listener to filter clear button');
    });
  }, 1000); // Check after 1 second for any buttons that might have loaded
}

function hideRepWebClient() {
  const affiliateCode = localStorage.getItem('affiliateCode');
  
  if (affiliateCode === 'IDEAL') {
    // Create a style element to ensure it's hidden via CSS as well
    const style = document.createElement('style');
    style.textContent = `
      #repWebClientContainer {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
        height: 0 !important;
        width: 0 !important;
        position: absolute !important;
        z-index: -9999 !important;
        overflow: hidden !important;
      }
    `;
    document.head.appendChild(style);
    
    // Immediate check
    const hideElement = () => {
      const repWebClient = document.getElementById('repWebClientContainer');
      if (repWebClient) {
        repWebClient.style.setProperty('display', 'none', 'important');
        repWebClient.style.setProperty('visibility', 'hidden', 'important');
        repWebClient.style.setProperty('opacity', '0', 'important');
        repWebClient.style.setProperty('pointer-events', 'none', 'important');
        repWebClient.style.setProperty('height', '0', 'important');
        repWebClient.style.setProperty('width', '0', 'important');
        repWebClient.style.setProperty('position', 'absolute', 'important');
        repWebClient.style.setProperty('z-index', '-9999', 'important');
        repWebClient.style.setProperty('overflow', 'hidden', 'important');
      }
    };

    // Check immediately
    hideElement();

    // Set up recurring checks to ensure it stays hidden
    const checkInterval = setInterval(hideElement, 500);
    
    // Also check at specific intervals for dynamic insertion
    [1000, 2000, 3000, 5000, 10000].forEach(time => {
      setTimeout(hideElement, time);
    });
    
    // Set up an observer to catch any future insertions
    const observer = new MutationObserver((mutations) => {
      hideElement();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  }
}

async function changeLogo() {
  const affiliateCode = fetchAffiliateCode();
  //console.log('Affiliate code at start of changeLogo:', affiliateCode);

  // Update logo link, passing the fetched code
  updateLogoLink(affiliateCode);
  
  // Update the actual logo image, passing the fetched code
  await updateLogoImage(affiliateCode);
  
  // Log the metafield value using the window variable
  console.log('Primary Brand Collection Metafield VALUE in MAIN:', typeof window.primaryBrandCollection, window.primaryBrandCollection);
  
  // Hide rep web client
  hideRepWebClient();

  const validAffiliateCodes = [
    'DRB', 'VEN', 'ENG', 'BSWD115', 'BSWD116', 'REV', 'ASA', 'WISH',
    'DERMATOLOGYOFCT', 'DERMATOLOGYOFCT2', 'DERMATOLOGYOFCT3',
    'DERMATOLOGYOFCT4', 'DERMATOLOGYOFCT5', 'DERMATOLOGYOFCT6',
    'DERMATOLOGYOFCT7','ALEXSAESTHETICS'
  ];

  if (affiliateCode) {
    await updateCartAttributes(affiliateCode);

    if (affiliateCode !== "STSMD") {
      const sectionRowElement = document.querySelector('#shopify-section-template--20562732679470__b21901e5-ad67-454f-884a-3f4ec97e6096 .section-row');
      if (sectionRowElement) {
        //sectionRowElement.style.removeProperty('display');
        //sectionRowElement.classList.remove('hidden');
      }

      const homepageSlideshowElement = document.querySelector('#shopify-section-template--20562732679470__45b11885-0a54-4060-b792-a8545f0772f3 .homepage-slideshow');
      if (homepageSlideshowElement) {
        //homepageSlideshowElement.classList.add('hidden');
      }

      setTimeout(async () => {
        const instaFeedElement = document.getElementById('insta-feed');
        if (instaFeedElement) {
          instaFeedElement.classList.add('display-none');
        }

        const headings = document.querySelectorAll('h2, h3');
        headings.forEach(heading => {
          if (heading.textContent.includes('Follow Us')) {
            heading.classList.add('display-none');
          }
        });

        try {
          await fetchPartnerProfileDetails(affiliateCode);
        } catch (error) {
          console.error('Error fetching partner profile details:', error);
        }
      }, 2000);
    } else {
      const sectionRowElement = document.querySelector('#shopify-section-template--20562732679470__b21901e5-ad67-454f-884a-3f4ec97e6096 .section-row');
      if (sectionRowElement) {
        //sectionRowElement.classList.add('hidden');
      }

      const homepageSlideshowElement = document.querySelector('#shopify-section-template--20562732679470__45b11885-0a54-4060-b792-a8545f0772f3 .homepage-slideshow');
      if (homepageSlideshowElement) {
        //homepageSlideshowElement.classList.remove('hidden');
      }
    }
  } else {
    const sectionRowElement = document.querySelector('#shopify-section-template--20562732679470__b21901e5-ad67-454f-884a-3f4ec97e6096 .section-row');
    if (sectionRowElement) {
      //sectionRowElement.classList.add('hidden');
    }

    const homepageSlideshowElement = document.querySelector('#shopify-section-template--20562732679470__45b11885-0a54-4060-b792-a8545f0772f3 .homepage-slideshow');
    if (homepageSlideshowElement) {
      //homepageSlideshowElement.classList.remove('hidden');
    }
  }

  if (affiliateCode && validAffiliateCodes.includes(affiliateCode)) {
    document.getElementById('provider-dropdown-container').style.display = 'block';
  }

  const navLinkElement = document.querySelector('.navlink.skin-type-icon');
  if (navLinkElement) {
    navLinkElement.style.setProperty('transition', 'opacity 0.5s ease', 'important');
    navLinkElement.style.setProperty('opacity', '1', 'important');
  }
}

// Add this cache object near the top of the file (after existing variables)
const logoUrlCache = {};
let logoCheckAttempts = {};
const MAX_LOGO_CHECK_ATTEMPTS = 5;
let debounceTimer = null;

// The in-memory cache dies with every navigation, so a visitor whose stored
// affiliate code has no logo file paid 25 CDN 404s (5 patterns x 5 extensions)
// on EVERY page load - the biggest source of console errors on the site
// (measured 2026-08-20: ~25 404s/load probing SMITH_header_logo.*). Persist
// the probe result per code in localStorage for a day: one probe per browser
// per day, and returning visitors get their co-branded logo instantly.
const LOGO_CACHE_KEY = 'stsAffiliateLogoCache';
const LOGO_CACHE_TTL_MS = 24 * 60 * 60 * 1000;

function readPersistedLogoResult(affiliateCode) {
  try {
    const store = JSON.parse(localStorage.getItem(LOGO_CACHE_KEY) || '{}');
    const entry = store[affiliateCode];
    if (entry && typeof entry.ts === 'number' && (Date.now() - entry.ts) < LOGO_CACHE_TTL_MS) {
      return entry; // { url: string|null, ts }
    }
  } catch (e) { /* storage unavailable/corrupt - fall through to probing */ }
  return undefined;
}

function persistLogoResult(affiliateCode, url) {
  try {
    const store = JSON.parse(localStorage.getItem(LOGO_CACHE_KEY) || '{}');
    store[affiliateCode] = { url: url, ts: Date.now() };
    localStorage.setItem(LOGO_CACHE_KEY, JSON.stringify(store));
  } catch (e) { /* best-effort */ }
}

async function getAffiliateLogoUrl(affiliateCode) {
  // Check cache first to avoid repeated requests for missing logos
  if (logoUrlCache[affiliateCode] !== undefined) {
    return logoUrlCache[affiliateCode]; // Return cached result (null or URL)
  }

  // Then the persisted cache - survives navigations, expires after a day
  const persisted = readPersistedLogoResult(affiliateCode);
  if (persisted !== undefined) {
    logoUrlCache[affiliateCode] = persisted.url;
    return persisted.url;
  }
  
  // Initialize or increment logo check attempts counter
  logoCheckAttempts[affiliateCode] = (logoCheckAttempts[affiliateCode] || 0) + 1;
  
  // Stop trying after max attempts
  if (logoCheckAttempts[affiliateCode] > MAX_LOGO_CHECK_ATTEMPTS) {
    logoUrlCache[affiliateCode] = null;
    console.log(`Max attempts reached for ${affiliateCode} logo checks. Giving up.`);
    return null;
  }
  
  // Enhanced pattern search for logos
  const patterns = [
    `${affiliateCode}_header_logo`,
    `${affiliateCode}_mobile_logo`,
    `${affiliateCode}_Logo`,
    `${affiliateCode}_logo`,
    affiliateCode
  ];
  
  const extensions = ['.png', '.jpg', '.jpeg', '.svg', '.gif'];
  const baseCdnUrl = 'https://cdn.shopify.com/s/files/1/0740/5984/1838/files/';
  
  // Try each pattern with each extension
  for (const pattern of patterns) {
    for (const ext of extensions) {
      const url = `${baseCdnUrl}${pattern}${ext}`;
      const exists = await checkImageExists(url);
      if (exists) {
        console.log(`Found logo for ${affiliateCode} at: ${url}`);
        logoUrlCache[affiliateCode] = url; // Cache the result
        persistLogoResult(affiliateCode, url);
        return url;
      }
    }
  }
  
  console.log(`No custom logo found for affiliate code: ${affiliateCode}`);
  logoUrlCache[affiliateCode] = null; // Cache the negative result
  persistLogoResult(affiliateCode, null); // and keep it across page loads
  return null;
}

async function updateLogoImage(affiliateCode) {
  // If there's no affiliate code, set a default STS logo and return
  if (!affiliateCode) {
    console.log('No affiliate code provided, using default STS logo');
    
    // Get all possible logo elements (desktop and mobile)
    const logoElements = document.querySelectorAll('.header__logo img, .mobile-nav__logo img, .mobile-logo img');
    
    if (logoElements.length === 0) {
      console.log('Logo elements not found, will retry later');
      // Try again after a delay - mobile sometimes loads elements later
      setTimeout(() => updateLogoImage(affiliateCode), 1000);
      return;
    }
    
    // Default STS logo URL - use STSMD logo which should always exist
    const defaultLogoUrl = 'https://cdn.shopify.com/s/files/1/0740/5984/1838/files/STSMD_Logo.png';
    
    // Update all logo elements with the default logo
    logoElements.forEach(logo => {
      // Skip if this logo already has the correct URL to prevent mutation loops
      if (logo.getAttribute('src') === defaultLogoUrl) {
        return;
      }
      
      // Save original logo info if not already saved
      if (!logo.getAttribute('data-original-src')) {
        logo.setAttribute('data-original-src', logo.getAttribute('src'));
        logo.setAttribute('data-original-srcset', logo.getAttribute('srcset') || '');
      }
      
      // Set new logo with both src and srcset
      logo.setAttribute('src', defaultLogoUrl);
      logo.setAttribute('srcset', defaultLogoUrl);
      
      // Ensure the image is visible and loaded
      logo.style.visibility = 'visible';
      logo.style.opacity = '1';
    });
    
    return;
  }
  
  // Original code continues for when affiliateCode exists
  // Get all possible logo elements (desktop and mobile)
  const logoElements = document.querySelectorAll('.header__logo img, .mobile-nav__logo img, .mobile-logo img');
  
  if (logoElements.length === 0) {
    console.log('Logo elements not found, will retry later');
    // Try again after a delay - mobile sometimes loads elements later
    setTimeout(() => updateLogoImage(affiliateCode), 1000);
    return;
  }
  
  // Check if we have a custom logo for this affiliate
  const logoUrl = await getAffiliateLogoUrl(affiliateCode);
  
  if (logoUrl) {
    console.log(`Setting logo to: ${logoUrl} for affiliate code: ${affiliateCode}`);
    
    // Update all logo elements
    logoElements.forEach(logo => {
      // Skip if this logo already has the correct URL to prevent mutation loops
      if (logo.getAttribute('src') === logoUrl) {
        return;
      }
      
      // Save original logo info if not already saved
      if (!logo.getAttribute('data-original-src')) {
        logo.setAttribute('data-original-src', logo.getAttribute('src'));
        logo.setAttribute('data-original-srcset', logo.getAttribute('srcset') || '');
      }
      
      // Set new logo with both src and srcset
      logo.setAttribute('src', logoUrl);
      logo.setAttribute('srcset', logoUrl);
      
      // Ensure the image is visible and loaded
      logo.style.visibility = 'visible';
      logo.style.opacity = '1';
    });
    
    // Also update any background-image styles that might contain logos
    const headerLogoContainers = document.querySelectorAll('.header__logo, .mobile-nav__logo, .mobile-logo');
    headerLogoContainers.forEach(container => {
      const bgElements = container.querySelectorAll('[style*="background-image"]');
      bgElements.forEach(el => {
        // Skip if already has the correct URL
        if (el.style.backgroundImage.includes(logoUrl)) {
          return;
        }
        el.style.backgroundImage = `url(${logoUrl})`;
      });
    });
  } else {
    // If no logo found for this affiliate, use the default STS logo
    console.log(`No logo found for ${affiliateCode}, using default STS logo`);
    
    // Default STS logo URL
    const defaultLogoUrl = 'https://cdn.shopify.com/s/files/1/0740/5984/1838/files/STSMD_Logo.png';
    
    // Update all logo elements with the default logo
    logoElements.forEach(logo => {
      // Skip if this logo already has the correct URL to prevent mutation loops
      if (logo.getAttribute('src') === defaultLogoUrl) {
        return;
      }
      
      // Save original logo info if not already saved
      if (!logo.getAttribute('data-original-src')) {
        logo.setAttribute('data-original-src', logo.getAttribute('src'));
        logo.setAttribute('data-original-srcset', logo.getAttribute('srcset') || '');
      }
      
      // Set new logo with both src and srcset
      logo.setAttribute('src', defaultLogoUrl);
      logo.setAttribute('srcset', defaultLogoUrl);
      
      // Ensure the image is visible and loaded
      logo.style.visibility = 'visible';
      logo.style.opacity = '1';
    });
  }
}

// Replace the setupLogoChangeObserver function with a debounced version
function setupLogoChangeObserver() {
  // This function now uses a debounce mechanism to avoid excessive updates
  const debouncedLogoUpdate = (mutationsList) => {
    // Clear any existing timer
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
    
    // Set a new timer
    debounceTimer = setTimeout(() => {
      const currentAffiliateCode = fetchAffiliateCode(); // Fetch code once
      if (currentAffiliateCode !== undefined) { // Ensure code is fetched before updating
        updateLogoImage(currentAffiliateCode);
        updateLogoLink(currentAffiliateCode); // Pass fetched code
      }
    }, 500); // 500ms debounce
  };
  
  // Create observer with the debounced callback
  const headerObserver = new MutationObserver(debouncedLogoUpdate);
  
  // Observe only specific parts of the DOM to reduce unnecessary triggers
  const headerElements = document.querySelectorAll('.header, .header__logo, .mobile-nav, .mobile-nav__logo');
  
  if (headerElements.length > 0) {
    headerElements.forEach(el => {
      headerObserver.observe(el, { 
        childList: true, 
        subtree: true,
        attributes: true,
        attributeFilter: ['src', 'srcset', 'style', 'class']
      });
    });
  } else {
    // If we can't find specific header elements yet, observe the body with a more
    // restricted configuration to reduce chances of infinite loops
    headerObserver.observe(document.body, { 
      childList: true,
      subtree: false  // Only direct children of body, not the entire DOM tree
    });
    
    // Try again after a short delay to find specific elements
    setTimeout(() => {
      headerObserver.disconnect();
      setupLogoChangeObserver();
    }, 1000);
  }
  
  // Add a one-time check after a delay rather than an interval
  setTimeout(() => {
    const affiliateCode = localStorage.getItem('affiliateCode') || sessionStorage.getItem('affiliateCode');
    // Call updateLogoImage even if there's no affiliate code
    updateLogoImage(affiliateCode);
    updateLogoLink(affiliateCode); // Also call updateLogoLink
  }, 500);
}

// Also modify this listener to use debouncing
window.addEventListener('resize', () => {
  if (debounceTimer) {
    clearTimeout(debounceTimer);
  }
  
  debounceTimer = setTimeout(() => {
    const affiliateCode = localStorage.getItem('affiliateCode') || sessionStorage.getItem('affiliateCode');
    // Call updateLogoImage even if there's no affiliate code
    updateLogoImage(affiliateCode);
  }, 500);
});

document.addEventListener('DOMContentLoaded', () => {
  changeLogo();
  // observeUrlChanges(); // Call commented out as function is not defined
  setupLogoChangeObserver();
});

// Also run logo update when window loads (ensures images are loaded)
window.addEventListener('load', () => {
  const affiliateCode = fetchAffiliateCode(); // Use robust fetcher
  // Call updateLogoImage regardless of whether there's an affiliate code
  // This will ensure the default STS logo is used when no affiliate code exists
  updateLogoImage(affiliateCode);
  updateLogoLink(affiliateCode); // Also update link on load
});